// extracted by mini-css-extract-plugin
export default {"editRoles":"Roles_editRoles__6RR+h","section":"Roles_section__XDerD","active":"Roles_active__FJd2b"};